import { render } from "./AsTechQuestion.vue?vue&type=template&id=aa0ac7b0&scoped=true&ts=true"
import script from "./AsTechQuestion.vue?vue&type=script&lang=ts"
export * from "./AsTechQuestion.vue?vue&type=script&lang=ts"

import "./AsTechQuestion.vue?vue&type=style&index=0&id=aa0ac7b0&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa0ac7b0"]])

export default __exports__